module.exports = __webpack_public_path__ + "img/big.79a89a3e.jpg";